import type { ITranslationObject } from "@krea/shared/types/common";

import en from "./en.json";
import fi from "./fi.json";
import sv from "./sv.json";

export const bidsTranslations: ITranslationObject<typeof en> = {
  en,
  sv,
  fi,
  namespace: "bids",
};

export interface IBidsTranslations {
  bids: (typeof bidsTranslations)["en"]["bids"];
}
